function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#0350DF;}\r\n\t.st1{fill:#FFFFFF;}\r\n");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: -0.2,
  y: -0.3,
  className: "st0",
  width: 22.4,
  height: 22.5
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M7,18h8c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4H7c-0.2,0-0.4-0.2-0.4-0.4S6.8,18,7,18z M15,17.4 c-0.1,0.1-0.2,0.1-0.3,0.1H7.2c-0.2,0-0.3-0.1-0.3-0.3C6.9,17.1,7,17,7,16.9l1.4-0.8l0,0l0.7-9.7H8.8c-0.4,0-0.7-0.3-0.7-0.7V3.2 h2.6v2.1h0.6V3.2h2.6v2.6c0,0.4-0.3,0.7-0.7,0.7h-0.4l0.9,9.7l1.4,0.8C15.1,17.1,15.1,17.3,15,17.4z"
});

var SvgChessableLogoSmall = function SvgChessableLogoSmall(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChessableLogoSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chessable_logo_small.61070406.svg";
export { ForwardRef as ReactComponent };